import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "successText", "className"];
import React, { useState } from 'react';
import { Button as CarnicaButton } from '@carnica/ui-kit';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { useIsDesktopDimension } from '@beef/ui-kit/hooks';
import { canUseClipboard, canUseShare, clipboardData, shareData } from '@carnica/utils';
import PropTypes from 'prop-types';
import { enhancedConnect } from "../../utils";
import { Tooltip } from "./Tooltip";
var _SharedButton = function _SharedButton(_ref) {
  var children = _ref.children,
    successText = _ref.successText,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var isDesktop = useIsDesktopDimension();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShowTooltip = _useState2[0],
    setShowTooltip = _useState2[1];
  var handleSharedPage = function handleSharedPage() {
    if (canUseClipboard() && isDesktop) {
      clipboardData({
        text: window.location.href,
        onFinally: setShowTooltip
      });
    }
    if (canUseShare() && !isDesktop) {
      shareData({
        text: window.document.title,
        url: window.location.href,
        title: window.document.title
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "components-SharedButton"
  }, /*#__PURE__*/React.createElement(CarnicaButton, _extends({
    onClick: handleSharedPage
  }, props), children), isShowTooltip && isDesktop && /*#__PURE__*/React.createElement(Tooltip, {
    text: successText
  }));
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export var SharedButton = compose(enhancedConnect({
  children: PropTypes.string,
  className: PropTypes.string,
  successText: PropTypes.string,
  size: PropTypes.oneOf([null, 'l', 'm']),
  mode: PropTypes.oneOf([null, 'default', 'inline']),
  view: PropTypes.oneOf([null, 'primary', 'secondary', 'destructive']),
  width: PropTypes.oneOf([null, 'default', 'full'])
}), withAutoMetric.Element(function (props) {
  return {
    name: 'Button',
    text: props.children
  };
}))(_SharedButton);